<template>
  <div class="analysis-list">
    <div v-if="list.length">
      <div v-for="(item, index) in list" :key="index" class="analysis-item">
        <div class="analysis-title-row" v-if="getTitle(item) || getTag(item)">
          <div class="analysis-title" v-if="getTitle(item)">{{ getTitle(item) }}</div>
          <span v-if="getTag(item)" class="analysis-tag">{{ getTag(item) }}</span>
        </div>
        <div class="analysis-body" :class="{ 'analysis-body--text-only': !item.img }">
          <div class="analysis-image-box" v-if="item.img">
            <img :src="item.img" alt="" />
            <div class="analysis-image-caption" v-if="getImageCaption(item)">
              {{ getImageCaption(item) }}
            </div>
          </div>
          <div class="analysis-texts">
            <div
              v-for="(row, rowIndex) in getRows(item)"
              :key="row.label + '-' + rowIndex"
              class="analysis-text"
            >
              <span v-if="row.label" class="analysis-row-label">【{{ row.label }}】</span>
              <span class="analysis-row-value">{{ row.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EMPTY_TEXT,
  isValidValue,
  pickText,
  toArray,
} from '../helpers';

export default {
  name: 'DiagnosisAnalysisList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getTitle(item) {
      return item.name || item.symbol || '';
    },
    getTag(item) {
      const tag = pickText(item.tagDesc, item.levelDesc, item.symbol, item.result, '');
      return tag === EMPTY_TEXT ? '' : tag;
    },
    getImageCaption(item) {
      const title = this.getTitle(item);
      // eslint-disable-next-line prefer-template
      return title ? '本次(' + title + ')' : '';
    },
    getRows(item) {
      const rows = [];
      if (item.desc) rows.push(this.normalizeRow('', item.desc));
      if (item.aiExplain) rows.push(this.normalizeRow('病理意义', item.aiExplain));
      if (item.analysis) {
        rows.push(this.normalizeRow('诊断分析', toArray(item.analysis).join('、')));
      }
      return rows.filter((row) => isValidValue(row.value));
    },
    normalizeRow(label, value) {
      const text = String(value == null ? '' : value);
      if (label) return { label, value: text };

      const labelMatch = text.match(/^\s*[【[]\s*([^】\]]+)\s*[】\]]\s*/);
      if (!labelMatch) return { label: '', value: text };

      return {
        label: labelMatch[1],
        value: text.slice(labelMatch[0].length),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-list {
  padding: 0 14px;
}

.analysis-item {
  padding: 6px 0 10px;
  border-bottom: 1px dotted #9e6c41;
}

.analysis-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.analysis-title {
  min-width: 44px;
  color: #68311d;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
}

.analysis-tag {
  display: inline-flex;
  align-items: center;
  min-height: 14px;
  padding: 0 4px;
  border: 1px solid #ff8d8d;
  border-radius: 2px;
  color: #ff5b5b;
  font-size: 7.5px;
  line-height: 12px;
  font-weight: 600;
}

.analysis-body {
  display: grid;
  grid-template-columns: 52px 1fr;
  gap: 10px;
  align-items: start;
}

.analysis-image-box {
  text-align: center;

  img {
    display: block;
    width: 52px;
    height: 52px;
    object-fit: cover;
  }
}

.analysis-image-caption {
  margin-top: 2px;
  color: #68311d;
  font-size: 8.5px;
  line-height: 12px;
  font-weight: 400;
}

.analysis-body--text-only {
  grid-template-columns: 1fr;
}

.analysis-text {
  position: relative;
  padding-left: 7px;
  color: #68311d;
  font-size: 14px;
  line-height: 25px;
  text-align: justify;
  white-space: pre-line;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: #68311d;
  }

  .analysis-row-label {
    font-weight: 600;
  }
}

</style>
